import React from "react";
import InfoBanner from '../InfoBanner'


/**
 * Componente para mostrar la new Desbloqueando el potencial (Contenido estático).
 *
 * @component
 *
 */

export const DesbloqueandoPotencial = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  React.useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
  }, []);

  const url = window.location.href;

  return (
    <section id="blog-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">Blog</span>
        </h2>
      </div>
      <InfoBanner
        section={'Desbloqueando Potencial'}
        tittle={'Desbloqueando el potencial de los datos para generar valor'}
        readingTime={'Tiempo de lectura 5 minutos'}
        keywords={['Transformación Digital', 'Big Data']}
        urlDesktop={'/img/blog/DesbloqueandoPotencial/DesbloqueandoPotencial_img1.webp'}
        urlMobile={'/img/blog/DesbloqueandoPotencial/DesbloqueandoPotencial_img1_mob.webp'}
      />
      <div className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
              En la actual era digital, el éxito empresarial se forja en la comprensión profunda y la utilización estratégica de los datos, incluyendo elementos clave como Big Data y Análisis de Datos. Este desafío se convierte en una oportunidad para generar valor y destacar la importancia de la Transformación Digital.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <img
                style={{ width: "100%" }}
                alt="Desbloqueando Potencial"
                className="img-responsive"
                src="/img/blog/DesbloqueandoPotencial/DesbloqueandoPotencial_img2.webp"
              ></img>
              <h2 className="img3Text">La comprensión y utilización estratégica de los datos genera valor e impulsa el éxito empresarial en la era digital.</h2>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>El desafío de los datos:</b>
                <br></br>
                <br></br>
                El análisis guía estrategias de marketing, desde técnicas simples hasta modelos econométricos avanzados. Estos modelos identifican relaciones complejas, como la influencia de factores externos en el desempeño comercial.
                <br></br>
                <br></br>
                Aplicaciones vitales incluyen la segmentación de audiencia, detección de patrones de compra y evaluación de campañas.
                <br></br>
                <br></br>
                Cada análisis se adapta al contexto específico del negocio, utilizando herramientas tecnológicas y enfoques analíticos personalizados para desbloquear la verdadera riqueza de los datos.
                <br></br>
                <br></br>
                En este análisis de datos la recolección de información es crucial. Algunas marcas carecen de trazabilidad consistente, lo que limita sus capacidades analíticas y de toma de decisiones inteligentes. Por eso, la confianza en consultoras como RAM y la compartición de información por parte de los clientes abren oportunidades para análisis profundos, generando un impacto positivo en las estrategias comerciales. 
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  alt="Desbloqueando Potencial"
                  className="img-responsive"
                  src="/img/blog/DesbloqueandoPotencial/DesbloqueandoPotencial_img3.webp"
                ></img>
                <h2 className="img3Text">
                El análisis de datos guía estrategias de marketing, mejorando la segmentación, la evaluación de campañas y la comprensión del comportamiento del consumidor.
                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                La digitalización no se limita al mundo en línea; también transforma lo offline. Soluciones digitales, como cámaras con internet e inteligencia artificial, capturan datos valiosos en entornos tradicionales. Esta transformación genera información que mejora la evaluación de campañas y permite una segmentación precisa de audiencias, ofreciendo una imagen completa del comportamiento del consumidor.
                <br></br>
                <br></br>
                En este proceso, recordemos que el consumidor es el centro. La obtención y análisis de datos son fundamentales para descifrar patrones de comportamiento únicos en grupos y generaciones específicos, entenderlo, evaluar la efectividad de la comunicación y el posicionamiento de la marca. Es así que, la estrategia de medios debe identificar los puntos de contacto, traduciéndose en una comprensión más profunda del comportamiento del cliente.
                <br></br>
                <br></br>
                En el futuro, la creatividad impulsada por datos será la clave. El desarrollo de productos basado en datos y estrategias de marketing basadas en datos marcarán la pauta para una conexión más profunda con el consumidor. La personalización en marketing, junto con la protección de la privacidad, se convertirá en la fórmula maestra para el éxito.
                <br></br>
                <br></br>
                La importancia de los datos no solo radica en su valor actual, sino en la capacidad de anticipar las necesidades y deseos del consumidor, preparándose para un futuro donde la relación entre el mundo online y offline se vuelve más integrada y valiosa.
              </p>
            </div>
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? "block" : "none" }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Desbloqueando el potencial`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};
